import { t } from 'i18next';
import React from 'react';
import Placeholder from '../../../../../../components/utility/placeholder';
import { tKeys } from '../../../../../../translations/keys';
import COLORS from '../../../../../../constants/colors';
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, VStack, Box, Text as ChakraText, } from '@chakra-ui/react';
import LoadingWrapper from '../../../../../../components/utility/loading-wrapper';
import { BusyIndicator } from '../../../../../../components/utility/busy-indicator';
import { DocumentListSection } from './document-list-section/index.web';
function DocumentList({ kind, listLayoutType, isDocumentDataLoading, optionsOrder, onLayoutIconPress, onDocumentPress, documentsData: data, setOrderBy, orderBy, selectedDocumentRelation, }) {
    // Render functions
    const getButtonColor = layoutType => {
        return layoutType === listLayoutType
            ? COLORS.Govrn.Blue.T500.value
            : 'transparent';
    };
    const getIconColor = layoutType => {
        return layoutType === listLayoutType ? 'white' : COLORS.Text.T300.value;
    };
    const getDocumentCountText = (count) => {
        return count === 1 ? `(${count} document)` : `(${count} documents)`;
    };
    console.log(selectedDocumentRelation);
    // Render
    return (<VStack width={'full'} alignItems={'flex-start'} overflow={'auto'} height={'full'} bgColor={COLORS.BG.value} pt={0} spacing={0}>
      <LoadingWrapper isLoading={isDocumentDataLoading}>
        <VStack width={'100%'} height={'100%'} pt={0} spacing={0}>
          <BusyIndicator isEmpty={!data?.length} placeholder={<Placeholder imageType={'folder'} title={t(tKeys.repository.placeholder.title)} subTitle={t(tKeys.repository.placeholder.subtitle)}/>}>
            <Accordion width={'100%'} allowMultiple defaultIndex={data?.length === 1 ? [0] : undefined}>
              {data.map(({ title, data: categoryData }, index) => {
            const categoryTitleStyle = {
                fontWeight: 'semibold',
                fontSize: '16px',
            };
            return (<AccordionItem key={index} border="none" borderBottomWidth="1px" borderColor="gray.200">
                    <h2>
                      <AccordionButton py={3} _hover={{ bg: 'gray.50' }} _expanded={{ bg: 'gray.50' }}>
                        <AccordionIcon mr={2}/>
                        <Box flex="1" textAlign="left">
                          <ChakraText {...categoryTitleStyle}>
                            {`${t(title)} ${getDocumentCountText(categoryData.length)}`}
                          </ChakraText>
                        </Box>
                      </AccordionButton>
                    </h2>
                    <AccordionPanel padding={0} bg={COLORS.White.T500.value}>
                      <DocumentListSection key={index} data={categoryData} kind={kind} title="" listLayoutType={listLayoutType} onDocumentPress={onDocumentPress} setOrderBy={setOrderBy} orderBy={orderBy} optionsOrder={optionsOrder} documentRelation={selectedDocumentRelation}/>
                    </AccordionPanel>
                  </AccordionItem>);
        })}
            </Accordion>
          </BusyIndicator>
        </VStack>
      </LoadingWrapper>
    </VStack>);
}
export default DocumentList;
